import { Col, FormGroup, FormSection, Row, Text, TextInput } from '@ksyos/design-system';
import type { OsasEvaluationData } from '@common/validation/customControls/osas/osasEvaluationSchemas/types';
import { AssetCategory } from '@common/enums';
import { useProcessActivityEditContext } from '@frontend/utils/hooks/useProcessActivityContext';
import { TextAreaFormGroup } from '../../../processActivityFormGroupFields';
import { ReportFormSection } from './RapportFormSection';
import { UseFormSection } from './UseFormSection';

export function SPTFormSections() {
    const { data, errors, onChange } = useProcessActivityEditContext<OsasEvaluationData>();

    return (
        <>
            <ReportFormSection
                data={{
                    sptReportEndDate: data.sptReportEndDate,
                    sptReportStartDate: data.sptReportStartDate,
                }}
                fieldKey={AssetCategory.sptReport}
                title="SPT rapport"
            />

            <UseFormSection fieldKey="spt" />

            <FormSection title="Waarden">
                <FormGroup
                    hasErrors={errors.has('supinePositionFrom') || errors.has('supinePositionTo')}
                    label="Rugligging"
                >
                    <Row columnGap={1}>
                        <Col span={1}>
                            <Text
                                paddingTop={2}
                                size="sm"
                            >
                                van
                            </Text>
                        </Col>
                        <Col span={3}>
                            <TextInput
                                error={errors.get('supinePositionFrom')}
                                onChange={(e) =>
                                    onChange(
                                        { supinePositionFrom: e.target.value ? e.target.value : null },
                                        'supinePositionFrom'
                                    )
                                }
                                value={data.supinePositionFrom ?? ''}
                            />
                        </Col>
                        <Col span={1}>
                            <Text
                                paddingTop={2}
                                size="sm"
                            >
                                %
                            </Text>
                        </Col>
                        <Col span={1}>
                            <Text
                                paddingTop={2}
                                size="sm"
                            >
                                naar
                            </Text>
                        </Col>
                        <Col span={3}>
                            <TextInput
                                error={errors.get('supinePositionTo')}
                                onChange={(e) =>
                                    onChange(
                                        { supinePositionTo: e.target.value ? e.target.value : null },
                                        'supinePositionTo'
                                    )
                                }
                                value={data.supinePositionTo ?? ''}
                            />
                        </Col>
                        <Col span={1}>
                            <Text
                                paddingTop={2}
                                size="sm"
                            >
                                %
                            </Text>
                        </Col>
                    </Row>
                </FormGroup>

                <TextAreaFormGroup
                    fieldKey="sptRemark"
                    label="Toelichting"
                />
            </FormSection>
        </>
    );
}
